export const DEFAULT_RECAPTCHA_CONFIG = {
  attempts: 3,
  baseDelayMs: 1000,
  jitterMs: 500
} as const;

export const RECAPTCHA_FALLBACK_REASON = 'RECAPTCHA_SCORE_TOO_LOW' as const;
export type RecaptchaFallbackReason = typeof RECAPTCHA_FALLBACK_REASON;

export const RECAPTCHA_V2_SITE_KEY = import.meta.env.VITE_RECAPTCHA_V2_SITE_KEY;
